
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageTitle } from "@/components/PageTitle";
import { CTASection } from "@/components/CTASection";
import { LaserDentistryHero } from "./LaserDentistryHero";
import { LaserDentistryOverview } from "./LaserDentistryOverview";
import { LaserDentistryServices } from "./LaserDentistryServices";
import { LaserDentistryTestimonials } from "./LaserDentistryTestimonials";
import { LaserDentistryFAQ } from "./LaserDentistryFAQ";
import { LaserDentistryRelated } from "./LaserDentistryRelated";
import { LaserDentistryCTA } from "./LaserDentistryCTA";

const LaserDentistryPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <PageTitle title="Laser Dentistry in Nagpur | Cost of Laser Dentistry in Nagpur" />
      <Header />
      
      <LaserDentistryHero />
      <LaserDentistryOverview />
      <LaserDentistryServices />
      <LaserDentistryTestimonials />
      <LaserDentistryFAQ />
      <LaserDentistryRelated />
      <LaserDentistryCTA />
      
      <Footer />
    </div>
  );
};

export default LaserDentistryPage;
